import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = function DataPoints() {
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  const dataPoints = useSelector((state) => state.agreementsAnalysis.chartData.dataPoints);

  if (!dataPoints || !dataPoints.length) return null;
  return (
    <div className="data-points">
      {dataPoints.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              key={dataPoint.label}
              label={dataPoint.label}
              disableAnimation={isUserQa}
              value={dataPoint.count}
              type={dataPoint.currency ? "money" : "default"}
              currency={dataPoint.currency}
            />
          </div>
        );
      })}
    </div>
  );
};
